import React, { useState } from "react";
import { TextBox } from "devextreme-react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import "./NewForms.css";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks/hooks";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  disabled?: boolean | undefined;
  defaultValue?: string;
  placeholder?: string;
  width?: number;
}

export const NFTextInput = ({
  title,
  fieldName,
  required,
  showBorder,
  disabled = false,
  defaultValue,
  placeholder,
  width,
}: IProps) => {
  const { register, control } = useFormContext();
  const { errors, dirtyFields } = useFormState();
  const dispatch = useAppDispatch();
  const [isInitialized, setIsInitialized] = useState(false);
  const onChangeFunc = () => {
    if (isInitialized) {
      // dispatch(setFieldChanged({docId: activeTabId, hasChanged: true}));
    }
  };

  return (
    <Controller
      control={control}
      name={fieldName}
      defaultValue={defaultValue}
      rules={{
        required: required === true,
        onChange: (newValue: string) => {
          setIsInitialized(true);
        },
      }}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <>
          <div className={title ? "form-group" : ""}>
            {title && <label className={"form-label-sm"}>{title}</label>}
            <TextBox
              width={width}
              value={value}
              onValueChanged={(e) => {
                onChange(e.value);
                onChangeFunc();
              }}
              className="bg-light"
              readOnly={disabled === true ? true : undefined}
              style={{
                border: !showBorder ? "block" : showBorder ? "block" : "none",
              }}
              validationStatus={
                errors[fieldName]
                  ? "invalid"
                  : dirtyFields[fieldName]
                  ? "valid"
                  : "valid"
              }
              placeholder={placeholder}
            />
          </div>
        </>
      )}
    />
  );
};
